import {Direction, SideType} from "./transport";

export interface TrailerConditionReportModel {
    editableType: TrailerConditionReportType;
    entryTrailerConditionReportData: TrailerConditionReportDataEntry;
    exitTrailerConditionReportData: TrailerConditionReportDataEntry;
}

export interface SingleTrailerConditionReportModel extends TrailerConditionReportDataEntry {
    reportType: TrailerConditionReportType | null;
    orderId: string;
}

export interface TrailerConditionReportDataEntry {
    winch: boolean;
    plumb: boolean;
    spareWheelsNo: number | null;
    wedgesNo: number | null;
    actualTemp1: number | null;
    actualTemp2: number | null;
    damages: DamageModelWithDirection[] | DamageModelWithoutDirection[];
}

export interface DamageModelWithoutDirection {
    damageUpdateTime: Date | null | string;
    sideType: SideType;
    equipmentType: EquipmentType;
    damageType: DamageType;
    damageLocation?: DamageLocation;
}

export interface DamageModelWithDirection extends DamageModelWithoutDirection {
    direction: Direction;
}

export enum EquipmentType {
    TARPAULIN = "TARPAULIN",
    SIDE_BOARD = "SIDE_BOARD",
    LEG = "LEG",
    SPARE_WHEEL = "SPARE_WHEEL",
    WINCH = "WINCH",
    LIGHT = "LIGHT",
    PLUMB = "PLUMB",
    WEDGE = "WEDGE",
    WHEEL = "WHEEL",
    AGGREGATE = "AGGREGATE",
    BICYCLE_PROTECTION = "BICYCLE_PROTECTION"
}

export enum DamageType {
    SCRATCHED = "SCRATCHED",
    BENT = "BENT",
    TORN = "TORN",
    LEAKAGE = "LEAKAGE",
    CRACKED = "CRACKED",
    BROKEN = "BROKEN",
    DENT = "DENT",
    MISSING = "MISSING",
    OUT_OF_ORDER = "OUT_OF_ORDER"
}

export enum DamageTypeFirstLetter {
    SCRATCHED = "S",
    BENT = "b",
    TORN = "t",
    LEAKAGE = "Le",
    CRACKED = "Cr",
    BROKEN = "Br",
    DENT = "D",
    MISSING = "M",
    OUT_OF_ORDER = "O"
}

export enum DamageLocation {
    LEFT_TOP = "LEFT_TOP",
    RIGHT_TOP = "RIGHT_TOP",
    LEFT_BOTTOM = "LEFT_BOTTOM",
    RIGHT_BOTTOM = "RIGHT_BOTTOM",
    FRONT = "FRONT",
    CENTER = "CENTER",
    REAR = "REAR",
}

export enum TrailerConditionReportType {
    GIVE_BACK = "GIVE_BACK",
    PICK_UP = "PICK_UP",
    NONE = "NONE"
}